import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import TitleWidget from '../../core/TitleWidget';
import ListBox from '../../core/ListBox';

const StyledHeader = styled.header`
  position: relative;
  margin-bottom: ${rem('30px')};
  ${mediaqueries.lessThan('mobile')`
    h2 {
      padding-top: 0;
    }
  `};
`;

const StyledWidgetBox = styled.div`
  background-color: ${props => props.theme.colors.light};
  padding: ${props =>
    props.type === 'oraclehcm' || props.type === 'atresmedia_ia'
      ? rem('0px')
      : rem('30px')};
  margin-bottom: ${rem('20px')};
  ${mediaqueries.lessThan('mobile')`
    margin-bottom: ${rem('25px')};
    padding: ${rem('21px')} ${rem('14px')} ${rem('28px')} ${rem('14px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('15px')};
    padding-bottom: ${props =>
      props.type === 'oraclehcm' || props.type === 'atresmedia_ia'
        ? rem('0px')
        : rem('30px')};
  `};
  ${mediaqueries.lessThan('desktop')`
    height: ${props =>
      props.type === 'oraclehcm' || props.type === 'atresmedia_ia'
        ? rem('600px')
        : 'auto'};
  `};
  /** Ocultamos provisionalmente el menú del día */
  &.menuofday {
    display: none;
  }
`;

const StyledTitle = styled(TitleWidget)``;

const StyledList = styled(ListBox)`
  top: ${rem('14px')};
  position: absolute;
  right: 0;
  z-index: 2;
  top: ${rem('30px')};
  ${mediaqueries.lessThan('mobile')`
    top:${rem('15px')};
  `};
`;

export { StyledHeader, StyledWidgetBox, StyledTitle, StyledList };
